import React from "react";
import { Label, Popup, Icon } from "semantic-ui-react";

interface IFormFieldLabel {
  name: string;
  customFieldName: string;
  staffOnly: boolean;
  isReadonly: boolean;
  isFeeExist: boolean;
  isControllingField: boolean;
  stacked: boolean;
  renderAsLabel?: boolean; // determines whether to render as <label> or <p> (paragraph tag is used when there is no input field to associate with the label)
}

export function FormFieldLabel({
  name,
  customFieldName,
  isControllingField,
  staffOnly,
  isReadonly,
  isFeeExist,
  stacked,
  renderAsLabel = true,
}: IFormFieldLabel) {
  if (renderAsLabel) {
    const htmlFor = !isReadonly ? name : undefined; // htmlFor is only when the fields are editable
    return (
      <label htmlFor={htmlFor} className='control-label'>
        <FormFieldLabelContents
          name={name}
          customFieldName={customFieldName}
          staffOnly={staffOnly}
          isReadonly={isReadonly}
          isFeeExist={isFeeExist}
          isControllingField={isControllingField}
          stacked={stacked}
        />
      </label>
    );
  }

  return (
    <p className='tw-mb-2 tw-text-[13px] tw-font-bold'>
      <FormFieldLabelContents
        customFieldName={customFieldName}
        staffOnly={staffOnly}
        isReadonly={isReadonly}
        isFeeExist={isFeeExist}
        isControllingField={isControllingField}
        stacked={stacked}
      />
    </p>
  );
}

function FormFieldLabelContents({
  customFieldName,
  isControllingField,
  staffOnly,
  isReadonly,
  isFeeExist,
  stacked,
}: Partial<IFormFieldLabel>) {
  return (
    <>
      {customFieldName}
      {staffOnly &&
        (stacked ? (
          <Label size='small' circular color='grey' style={{ marginLeft: 10 }}>
            Staff Only
          </Label>
        ) : (
          <Popup
            content='For internal staff only'
            inverted
            trigger={
              <Icon size='large' style={{ marginBottom: 6, marginLeft: 4, color: "#5D5FEF" }} name='user circle' />
            }
          />
        ))}
      {!isReadonly && isFeeExist && isControllingField && !stacked && (
        <Popup
          content='This field is used to calculate a fee'
          inverted
          trigger={
            <div className='fee-icon-container'>
              <Icon className='fee-icon' name='dollar' />
            </div>
          }
        />
      )}
    </>
  );
}
